<template>
  <div class="merchant-info">
    <!-- 搜索栏 -->
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" size="small">
        <el-form-item label="商户名称">
          <el-input v-model="searchForm.merchantName" placeholder="请输入" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="searchForm.contactPerson" placeholder="请输入" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="searchForm.contactPhone" placeholder="请输入" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card shadow="hover" class="table-card">
      <el-table
        :data="tableData"
        border
        stripe
        highlight-current-row
        :current-row-key="selectedRowKey"
        row-key="id"
        style="width: 100%;"
        height="calc(100vh - 280px)"
        @row-click="handleRowClick"
      >
        <el-table-column prop="id" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="merchantName" label="商户名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contactPerson" label="联系人" width="100" align="center"></el-table-column>
        <el-table-column prop="contactPhone" label="联系电话" width="130" align="center"></el-table-column>
        <el-table-column prop="meterCount" label="费控表数量" width="110" align="center"></el-table-column>
        <el-table-column prop="prechargeTotal" label="预充值总金额" width="140" align="right">
          <template slot-scope="scope">¥{{ scope.row.prechargeTotal }}</template>
        </el-table-column>
        <el-table-column prop="chargedTotal" label="已充电总金额" width="140" align="right">
          <template slot-scope="scope">¥{{ scope.row.chargedTotal }}</template>
        </el-table-column>
        <el-table-column prop="unusedTotal" label="未使用总金额" width="140" align="right">
          <template slot-scope="scope">¥{{ scope.row.unusedTotal }}</template>
        </el-table-column>
        <el-table-column prop="withdrawnTotal" label="已提总金额" width="140" align="right">
          <template slot-scope="scope">¥{{ scope.row.withdrawnTotal }}</template>
        </el-table-column>
        <el-table-column prop="pendingTotal" label="待提总金额" width="140" align="right">
          <template slot-scope="scope">¥{{ scope.row.pendingTotal }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" align="center"></el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 商户详情抽屉 -->
    <merchant-info-details
      :visible.sync="drawerVisible"
      :merchant-data="selectedMerchant"
    />
  </div>
</template>

<script>
import MerchantInfoDetails from './components/merchantInfoDetails.vue'

export default {
  name: 'MerchantInfo',
  components: {
    MerchantInfoDetails
  },
  data() {
    return {
      searchForm: {
        merchantName: '',
        contactPerson: '',
        contactPhone: ''
      },
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      drawerVisible: false,
      selectedMerchant: null,
      selectedRowKey: null
    }
  },
  mounted() {
    this.generateMockData()
    this.loadTableData()
  },
  methods: {
    // 生成模拟数据
    generateMockData() {
      const companyNames = [
        '张三李四有限公司', '王五赵六科技', '创新能源集团', '智慧充电股份',
        '绿色出行科技', '新能源发展公司', '电力服务集团', '智能电网科技',
        '清洁能源股份', '电动车充电联盟', '快充技术公司', '充电桩运营中心',
        '能源管理科技', '充电网络股份', '电力投资公司', '智能充电系统',
        '新能源科技公司', '充电服务平台', '电力设备集团', '能源解决方案',
        '充电设施运营', '智能能源管理', '电力服务公司', '充电技术研究',
        '能源开发集团', '充电设备制造', '电力工程公司', '能源科技公司',
        '充电系统集成', '电力维护服务'
      ]
      
      const firstNames = ['张', '李', '王', '赵', '刘', '陈', '杨', '黄', '周', '吴']
      const lastNames = ['伟', '芳', '娜', '敏', '静', '秀英', '丽', '强', '磊', '军']
      
      this.allData = []
      for (let i = 1; i <= 30; i++) {
        const companyName = companyNames[Math.floor(Math.random() * companyNames.length)] + (i > 20 ? `(${i})` : '')
        const contactPerson = firstNames[Math.floor(Math.random() * firstNames.length)] + 
                             lastNames[Math.floor(Math.random() * lastNames.length)]
        const phonePrefix = ['138', '139', '150', '151', '158', '159', '186', '187', '188', '199']
        const contactPhone = phonePrefix[Math.floor(Math.random() * phonePrefix.length)] + 
                            String(Math.floor(Math.random() * 100000000)).padStart(8, '0')
        
        const prechargeTotal = (Math.random() * 10000000 + 100000).toFixed(2)
        const chargedTotal = (Math.random() * 1000000 + 50000).toFixed(2)
        const unusedTotal = (Math.random() * 1000000 + 30000).toFixed(2)
        const withdrawnTotal = (Math.random() * 500000 + 20000).toFixed(2)
        const pendingTotal = (Math.random() * 500000 + 10000).toFixed(2)
        const meterCount = Math.floor(Math.random() * 500) + 50
        
        const year = 2024 + Math.floor(Math.random() * 2)
        const month = String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')
        const day = String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')
        const hour = String(Math.floor(Math.random() * 24)).padStart(2, '0')
        const minute = String(Math.floor(Math.random() * 60)).padStart(2, '0')
        const second = String(Math.floor(Math.random() * 60)).padStart(2, '0')
        const createTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`
        
        this.allData.push({
          id: i,
          merchantName: companyName,
          contactPerson: contactPerson,
          contactPhone: contactPhone,
          meterCount: meterCount,
          prechargeTotal: parseFloat(prechargeTotal).toLocaleString('zh-CN', { minimumFractionDigits: 2 }),
          chargedTotal: parseFloat(chargedTotal).toLocaleString('zh-CN', { minimumFractionDigits: 2 }),
          unusedTotal: parseFloat(unusedTotal).toLocaleString('zh-CN', { minimumFractionDigits: 2 }),
          withdrawnTotal: parseFloat(withdrawnTotal).toLocaleString('zh-CN', { minimumFractionDigits: 2 }),
          pendingTotal: parseFloat(pendingTotal).toLocaleString('zh-CN', { minimumFractionDigits: 2 }),
          createTime: createTime
        })
      }
      this.total = this.allData.length
    },

    // 加载表格数据
    loadTableData() {
      let filteredData = [...this.allData]
      
      // 搜索过滤
      if (this.searchForm.merchantName) {
        filteredData = filteredData.filter(item => 
          item.merchantName.includes(this.searchForm.merchantName)
        )
      }
      if (this.searchForm.contactPerson) {
        filteredData = filteredData.filter(item => 
          item.contactPerson.includes(this.searchForm.contactPerson)
        )
      }
      if (this.searchForm.contactPhone) {
        filteredData = filteredData.filter(item => 
          item.contactPhone.includes(this.searchForm.contactPhone)
        )
      }
      
      // 分页
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      this.tableData = filteredData.slice(start, end)
      this.total = filteredData.length
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.loadTableData()
    },

    // 行点击
    handleRowClick(row) {
      this.selectedRowKey = row.id
    },

    // 显示详情
    showDetail(row) {
      this.selectedMerchant = row
      this.selectedRowKey = row.id
      this.drawerVisible = true
    },

    // 每页条数变化
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadTableData()
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadTableData()
    }
  }
}
</script>

<style scoped lang="scss">
.merchant-info {
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  overflow: hidden;
  box-sizing: border-box;
}

.search-card {
  flex-shrink: 0;
  
  ::v-deep .el-card__body {
    padding: 12px 16px;
  }
}

.table-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  
  ::v-deep .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 12px;
    overflow: hidden;
  }
}

.pagination-container {
  margin-top: 12px;
  text-align: right;
  flex-shrink: 0;
}
</style>